import { CustomAccordion } from '@/components/blocks/DpGroupAccordionPageLink/parts/CustomAccordion';
import { CustomAccordionDetails } from '@/components/blocks/DpGroupAccordionPageLink/parts/CustomAccordionDetails';
import { CustomAccordionSummary } from '@/components/blocks/DpGroupAccordionPageLink/parts/CustomAccordionSummary';
import { titleSX } from '@/components/blocks/DpGroupAccordionPageLink/styles';
import { linkSX } from '@/components/blocks/DpGroupPageLink/styles';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack, SxProps, Typography } from '@mui/material';

export const DpFooterAccordionLinkFrame: React.FC<{
	title: string;
	isfirst?: boolean;
	children: React.ReactNode;
}> = ({ title, isfirst = false, children }) => (
	<CustomAccordion square={true} disableGutters={true} elevation={0} isfirst={isfirst}>
		<CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
			<Typography sx={titleSX}>{title}</Typography>
		</CustomAccordionSummary>
		<CustomAccordionDetails>
			<Stack spacing="14px" mb={2}>
				{children}
			</Stack>
		</CustomAccordionDetails>
	</CustomAccordion>
);

export const DpFooterAccordionLink: React.FC<{
	id?: string;
	href?: string;
	target?: string;
	sx?: SxProps;
	children: React.ReactNode;
}> = ({ id, href, target, sx, children }) => (
	<Linkable data-testid={id} id={id} href={href} sx={combineSX([linkSX, sx])} target={target}>
		{children}
	</Linkable>
);
